// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2nXBZ","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1CAAJ"};